export default __webpack_public_path__ + "static/media/p4.32033c72.png";